import { Share as ShareIcon } from '@mui/icons-material';
import { Button, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { toastSuccess } from 'modules/utils';
import React, { FC, useCallback } from 'react';
import { useStyles } from './ShareButton.styles';

interface ShareButtonProps {
  link?: string;
}

export const ShareButton: FC<ShareButtonProps> = ({ link = window.location.href }) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const copyMatchLinkHandler = useCallback(() => {
    navigator?.clipboard?.writeText(link as string);
    toastSuccess('Link has been copied to clipboard.');
  }, [link]);

  return (
    <>
      {fullScreen ? (
        <IconButton onClick={copyMatchLinkHandler} aria-label="share">
          <ShareIcon fontSize="medium" />
        </IconButton>
      ) : (
        <Button
          size="medium"
          onClick={copyMatchLinkHandler}
          className={classes.shareButton}
          startIcon={<ShareIcon fontSize="medium" />}
        >
          Share
        </Button>
      )}
    </>
  );
};
